

























































import { State, Action, Getter, Mutation } from "vuex-class";
import { componentDataType } from "../types";
import { pageDataType } from "../types";
import { HOST } from "../global";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "BrandItem"
})
export default class BrandItem extends Vue {
  // @Getter("pageData") public pageData!: pageDataType;
  @Prop() public compData!: string | null;
  public HOST: string = HOST;
  // document.querySelector("a").innerText = document.querySelector("a").innerText.toLowerCase().replace(/\b(\w)/g, x => { return x.toUpperCase(); });
}
